import { property } from '@pristine-ts/metadata';

export class StripePaymentMethodModel {
  @property()
  id: string;

  @property()
  brand: string;

  @property()
  createdAt: Date;

  @property()
  expirationMonth: number;

  @property()
  expirationYear: number;

  @property()
  last4: string;
}